import { MaskedLines, Reveal, Overline } from "./shared";
import { LightArt } from "./LightArt";

const EXAMPLES = [
    "Logo formation through motion",
    "Interactive brand walls",
    "Motion-responsive installations",
    "Product launch installations",
    "Corporate reception installations",
    "Exhibition installations",
    "Experience centres",
];

export const Brands = () => (
    <section data-testid="brands-section" className="relative overflow-hidden py-32 md:py-48">
        <div className="mx-auto grid max-w-[1600px] items-center gap-16 px-6 md:px-12 lg:grid-cols-2 lg:gap-32">
            <div className="relative order-2 h-[50vh] border border-white/10 lg:order-1 lg:h-[70vh]">
                <LightArt variant="burst" hue="mixed" className="h-full w-full" />
                <span className="absolute bottom-6 left-6 font-mono-tech text-[10px] tracking-[0.35em] text-white/40">
                    KINETIC ELEMENTS — FORMING A MARK
                </span>
            </div>
            <div className="order-1 lg:order-2">
                <Overline>For Brands</Overline>
                <h2 className="mt-10 font-display text-4xl font-bold uppercase leading-[0.95] tracking-tight sm:text-5xl lg:text-6xl">
                    <MaskedLines lines={["Make your", "brand move."]} />
                </h2>
                <Reveal className="mt-10 max-w-lg">
                    <p className="text-lg font-light leading-relaxed text-white/60 md:text-xl">
                        A brand people can watch, walk through and remember. Kinetic installations turn launches, lobbies and exhibitions into experiences people film, share and talk about.
                    </p>
                </Reveal>
                <div className="mt-12 space-y-0">
                    {EXAMPLES.map((e, i) => (
                        <Reveal key={e} delay={i * 0.05} y={16}>
                            <div className="flex items-center gap-5 border-b border-white/8 py-3.5">
                                <span className="h-px w-6 bg-[#FFE8B6]/50 shadow-[0_0_8px_1px_rgba(255,214,140,0.35)]" />
                                <span className="text-sm font-light tracking-wide text-white/60 md:text-base">{e}</span>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </div>
    </section>
);
